var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 55,
    viewBox: "0 0 300 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2307_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.405 24.3383H98.7922V12.4422H131.814V6.42578H93.1177V12.5106V48.1988H123.336C129.9 48.4039 135.369 43.2079 135.574 36.6446C135.779 30.0812 130.583 24.6117 124.02 24.4066C123.815 24.3383 123.61 24.3383 123.405 24.3383ZM123.336 42.114H98.7922V30.0812H123.336C126.686 30.2179 129.284 32.9527 129.148 36.3027C129.079 39.4477 126.55 41.9773 123.336 42.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.084 27.2781C89.084 38.764 79.7859 48.1304 68.3001 48.1304H43.8926V42.114H68.3001C75.4104 42.114 81.4951 37.0548 82.8625 30.0812H50.8661V24.3383H82.7941C81.4268 17.4331 75.342 12.4422 68.3001 12.3738H43.8926V6.42578H68.3001C79.7859 6.42578 89.084 15.7922 89.084 27.2781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.577 26.7312C41.1577 21.9454 41.021 14.3565 36.2352 9.77583C33.979 7.65641 31.0392 6.42578 27.9626 6.42578H-0.0683594V48.1988H29.0565C35.6882 48.1988 41.0893 42.7977 41.0893 36.166C41.021 32.4741 39.3801 28.9873 36.577 26.7312ZM5.60621 12.4422H27.8943C31.1759 12.5106 33.7739 15.3137 33.6372 18.5953C33.5688 21.7403 31.0392 24.2699 27.8943 24.3383H5.60621V12.4422ZM28.9882 42.114H5.60621V30.0812H28.9882C32.3382 30.2179 34.9362 32.9527 34.7995 36.3027C34.7311 39.4477 32.2015 41.9773 28.9882 42.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.109 48.0621H171.331V41.5671H217.206V6.35742H165.109V48.0621ZM171.331 12.4422H211.053V35.5507H171.331V12.4422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.223 41.6355H258.569V48.1304H264.722V41.6355H300.069V6.35742H223.223V41.6355ZM264.654 12.4422H293.847V35.5507H264.654V12.4422ZM229.307 12.4422H258.501V35.5507H229.307V12.4422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.145 0H146.923V54.5579H153.145V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2307_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 54.5579,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo13);
export default __webpack_public_path__ + "static/media/logo-13.270d80648db1197e5a72c4e31746e32f.svg";
export { ForwardRef as ReactComponent };